import { scaffolderPlugin } from '@backstage/plugin-scaffolder';
import { createScaffolderFieldExtension } from '@backstage/plugin-scaffolder-react';
import { InfrastructureConfigLoader } from './InfrastructureConfigLoader';
import { InfrastructureConfigApplier } from './InfrastructureConfigApplier';
import { ApplicationPicker } from './ApplicationPicker';

export const InfraConfigLoaderExtension = scaffolderPlugin.provide(
  createScaffolderFieldExtension({
    name: 'InfrastructureConfigLoader',
    component: InfrastructureConfigLoader,
  }),
);

export const InfraConfigApplierExtension = scaffolderPlugin.provide(
  createScaffolderFieldExtension({
    name: 'InfrastructureConfigApplier',
    component: InfrastructureConfigApplier,
  }),
);

export const ApplicationPickerExtension = scaffolderPlugin.provide(
  createScaffolderFieldExtension({
    name: 'ApplicationPicker',
    component: ApplicationPicker,
  }),
);
